"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultCodegenConfig = {
    overwrite: true,
    documents: ["!./src/types/**/*"],
    hooks: { afterOneFileWrite: ["prettier --write"] },
};
exports.default = defaultCodegenConfig;
//# sourceMappingURL=default-codegen-config.js.map